import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import * as IInputs from '../../../../../interfaces/merchants/products/purchases/inputs';
import {
  inputPurchasingConfirmation,
  RestartError,
  ReturnTargetStepError,
} from '../../../../../redux/actions/merchants/products/purchases/inputs';
import { Dispatch } from '../../../../../redux/reducers/merchants/products/purchases/inputs';
import scrollToTop from '../../../../hoc/scrollToTop';
import PurchaseSubmitButton from '../common/buttons/PurchaseSubmitButton';
import PurchaseItemList from '../common/PurchaseItemList';
import PurchaseConfirmAlert from '../common/texts/PurchaseConfirmAlert';

interface ElementProps {
  schemeType: IPurchases.SchemeType;
  product: IPurchases.MerchantProduct;
  settings: IPurchases.SettingConfirmation;
  postable: boolean;
  onSubmit: () => void;
  onRestart: () => void;
  onReturnTargetStep: () => void;
  publicId: string;
}

interface StateProps {
  inputs: IInputs.State;
}

interface DispatchProps {
  actions: {
    handleSubmit: (
      schemeType: IPurchases.SchemeType,
      productId: string,
      inputs: IInputs.State,
    ) => Promise<void>;
  };
}
interface State {
  read?: boolean;
}

type Props = ElementProps & StateProps & DispatchProps & InjectedIntlProps;

class InputConfirmation extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  private async handleSubmit() {
    const {
      schemeType,
      inputs,
      onSubmit,
      onRestart,
      onReturnTargetStep,
    } = this.props;
    try {
      await this.props.actions.handleSubmit(
        schemeType,
        inputs.productId!,
        inputs,
      );
      onSubmit();
    } catch (e) {
      if (e instanceof ReturnTargetStepError) {
        onReturnTargetStep();
      }
      if (e instanceof RestartError) {
        onRestart();
      }
    }
  }

  public render() {
    const { intl, product, settings, postable, schemeType } = this.props;
    const labelType =
      schemeType === IPurchases.SchemeType.Subscription
        ? 'subscription'
        : 'ticketBook';
    return (
      <>
        <PurchaseConfirmAlert
          labelType={labelType}
          termsUrl="/terms"
          lawUrl={`/${this.props.publicId}/legal_notice`}
        />
        <PurchaseItemList
          labelType={labelType}
          merchantImage={
            product.image ? product.image.thumb && product.image.thumb.url : ''
          }
          merchantName={product.name}
          merchantId={this.props.publicId}
          price={product.price}
          expiryDate={settings.expiryDate}
        />
        <PurchaseSubmitButton
          type="button"
          disabled={!postable}
          postable={postable}
          value={intl.formatMessage({
            id: `purchases.inputConfirmation.submitButton.${labelType}`,
          })}
          onClick={this.handleSubmit}
        >
          {intl.formatMessage({
            id: `purchases.inputConfirmation.submitButton.${labelType}`,
          })}
        </PurchaseSubmitButton>
      </>
    );
  }
}

const mapStateProps = ({
  merchantsProductsPurchasesInputs,
}: {
  merchantsProductsPurchasesInputs: IInputs.State;
}): StateProps => ({
  inputs: merchantsProductsPurchasesInputs,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: {
    handleSubmit: (
      schemeType: IPurchases.SchemeType,
      productId: string,
      inputs: IInputs.State,
    ) => inputPurchasingConfirmation(schemeType, productId, inputs)(dispatch),
  },
});

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(injectIntl(scrollToTop(InputConfirmation)));
